import { FC, memo } from 'react'

import { ArrowRightIcon, Button, Text } from '@cash-me/react-components'

import useWindowSize from 'hooks/useWindowSize'
import { HowWorks as HowWorksModule } from 'modules/how-works'

import { cards } from './data'
import { HowWorksProps } from './how-works.model'

const HowWorks: FC<HowWorksProps> = memo(({ onClick }) => {
  const { isTablet } = useWindowSize()

  return (
    <HowWorksModule cards={cards} onClick={onClick}>
      <Text className="subtitle" size="caption" weight="medium" uppercase>
        Como funciona
      </Text>
      <Text as="h2" size="heading3" weight="medium">
        <Text as="span" size="heading3" weight="medium" color="var(--colors-pink-text-default)">
          Como solicitar {' '}
        </Text>
        o Empréstimo Online?
      </Text>
      <Text className="description" color="var(--colors-neutral-text-weak)">
        O processo é muito simples. Pedimos o mínimo de documentos e tudo acontece em etapas rápidas.
      </Text>
      {isTablet && (
        <Button size="lg" onClick={onClick} variants="default">
          Simular agora <ArrowRightIcon />
        </Button>
      )}
    </HowWorksModule>
  )
})

HowWorks.displayName = 'HowWorks'

export default HowWorks
